import { render, staticRenderFns } from "./viewDefect.vue?vue&type=template&id=377cb20b&scoped=true&"
import script from "./viewDefect.vue?vue&type=script&lang=js&"
export * from "./viewDefect.vue?vue&type=script&lang=js&"
import style0 from "./viewDefect.vue?vue&type=style&index=0&id=377cb20b&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "377cb20b",
  null
  
)

export default component.exports